import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { nanoid } from 'nanoid';
import { Observable, of, throwError } from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { ErrorStateInterface } from '../../../../app/error-treatment/interface/error-state.interface';

import { CharonRelation } from '../../helpers/charon/charon.enum';
import { IServiceResponseAdminApp } from '../../models/services/response-app/response-app.interface';
import { CaronteService } from '../caronte/caronte.service';
import { CharonBaseService } from '../charon-base/charon-base.service';
import { LoaderProfileService } from '../loader-profile/loader-profile.service';
import { StoreService } from '../store/store.service';

@Injectable({
  providedIn: 'root'
})
export class CoreService extends CharonBaseService {
  constructor(
    private storeService: StoreService,
    private router: Router,
    private loaderProfile: LoaderProfileService,
    private caronteService: CaronteService,
    protected httpClient: HttpClient
  ) {
    super(httpClient);
  }

  getApplicationInfo(): Observable<IServiceResponseAdminApp | any> {
    const correlationId = nanoid(16);
    return this.storeService.userToken.pipe(
      first(),
      switchMap((token) => {
        if (!token) {
          return of(false);
        }
        return this.caronteService.get(token, 'app', correlationId).pipe(
          first(),
          catchError((error) => {
            const errorState: ErrorStateInterface = {
              state: {
                error: {
                  correlationId,
                  type: error['type'],
                  status: error['status'],
                  statusCode: error['statusCode'],
                  url: error['url']
                }
              }
            };

            if (error.status === 403 || error.status === 401) {
              this.loaderProfile.denyAccess();
              this.router.navigateByUrl('negado', errorState);
              const err = new Error(error);
              return throwError(() => err);
            }

            this.router.navigateByUrl('erro', errorState);
            const err = new Error(error);
            return throwError(() => err);
          })
        );
      })
    );
  }

  /**
   * Chama a api de sessões para validar o tempo de permanência do usuário
   */
  validateSession() {
    const sessionGuid = sessionStorage.getItem('sessionGuid');
    const session = sessionGuid ? { session: sessionGuid } : {};

    return this.getCharonResponse(CharonRelation.SESSION, 'POST', undefined, session).pipe(
      map((data: { session: string }) => {
        if (data?.session) {
          sessionStorage.setItem('sessionGuid', data.session);
        }
      })
    );
  }
}
